/* global __APP_VERSION__ */
// __APP_VERSION__ is replaced at build time by vite.config.js (`define`).
// During a tagged deploy it holds the deploy tag (e.g. 2026-06-17-1430-a1b2c3d);
// for local builds it falls back to `git describe`, or "dev" if git is unavailable.
export const APP_VERSION =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'

if (typeof window !== 'undefined') {
  window.__APP_VERSION__ = APP_VERSION
  console.info(`%cCROWDS admin ${APP_VERSION}`, 'color:#3bd6c6')
}
